import { Component, Input } from "@angular/core";

@Component({
  selector: "app-custom-file-uploader",
  templateUrl: "./custom-file-uploader.component.html",
})
export class CustomFileUploaderComponent {
  // form
  @Input()
  control: any; // the form control

  // file uploader options
  @Input()
  placeholderText: string = "";
  @Input()
  dragNDropUnavailablePlaceholderText: string = "haz clic aquí";
  @Input()
  animation: boolean = false;
  @Input()
  accept: string = ""; // Specify the types of files that the server accepts (audio/*,video/*,image/*)
  @Input()
  multiple: boolean = false; // Disable/Enable multiple selection
  @Input()
  listVisible: boolean = true; // Hide/Show built-in list
  @Input()
  native: boolean = false; // Enable the same behavior as the native input field when multiple files are added
}
